<app-accordion
  *ngIf="user && month?.weeks?.length"
  [collapsed]="!expanded"
  class="availability-month-accordion">
  <app-accordion-header
    class="availability-month-accordion-header"
    [attr.data-cy]="
      'availability-month-accordion-' + (month?.startDate | date: 'MM')
    "
    [collapseOnHeaderClick]="true"
    (click)="toggleMonthCollapsed($event)">
    {{ month?.startDate | date: "MMMM yyyy" }}
    <div class="flex-spacer"></div>
  </app-accordion-header>
  <app-accordion-content>
    <div class="availability-month-accordion-content">
      <app-availability-week-item
        *ngFor="let week of month?.weeks; trackBy: trackByStartDateString"
        [week]="week"
        [user]="user">
      </app-availability-week-item>
    </div>
  </app-accordion-content>
</app-accordion>
